var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rule-content"},[_c('draggable',{staticClass:"drag-content",attrs:{"ghostClass":"sort-ghost","chosenClass":"sort-chosen"},on:{"change":_vm.changeRuleList},model:{value:(_vm.list),callback:function ($$v) {_vm.list=$$v},expression:"list"}},[_vm._t("default")],2),_vm._t("contentSuffix")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }